import React, { useEffect, useState, useRef, useMemo } from "react";

import { Button } from "react-bootstrap";

import { useDispatch, useSelector } from "react-redux";

import _ from "lodash";

import cx from "classnames";

import Header from "../../components/Header";
import { IKImage } from "imagekitio-react";
import { fetchPaletteIds } from "actions/brandKit/brandKit";
import { createBrandkitComponent, deleteBrandkitComponents, fetchBrandkitComponents, invalidateBrandkitComponent, invalidatePaletteComponent, renameBrandkitComponent, updateBrandkitComponents } from "actions/brandKit/components";
import EmptyMessage from "../../components/EmptyMessage";
import DeleteModal from "../../components/DeleteModal";
import Footer from "../../components/Footer";
import TruncatedTextWithTooltip from "components/TruncatedTextWithTooltip";

import styles from "../brandkit.elements.module.scss";
import useToastMessage from "../../components/toastMessageHook";
import Tooltip from "components/Tooltip";


const Options = [
    {
      name: "forms",
      label: "Forms",
      paletteType: "FORMS",
      title: "",
    },
    {
      name: "sections",
      label: "Sections",
      paletteType: "SECTIONS",
      title: "",
    },
    {
      name: "carousels",
      label: "Carousels",
      paletteType: "CAROUSELS",
      title: "",
    },
    {
      name: "assetGrids",
      label: "Asset Grids",
      paletteType: "ASSET_GRID",
      title: "",
    },
    {
      name: "menus",
      label: "Menus",
      paletteType: "MENUS",
      title: "",
    },
    {
      name: "seek",
      label: "Seek",
      paletteType: "SEEK",
      title: "",
    },
    {
      name: "embed",
      label: "Embed",
      paletteType: "EMBED",
      title: "",
    },
  ];

const defaultContentImage = "/public/cleverstory/v2/static/default_card.jpg";

function ComponentsBrandkit() {
  const availableFonts = useSelector((state) => _.get(state, "fonts.items"));

  const dispatch = useDispatch();

  const [state, setState] = useState({
    active: 'forms',
    label: 'Forms',
    paletteType: "FORMS",
    selected: [],
  });

  const [toggleBrandElements, setToggleBrandElements] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const workspace = useSelector(state => _.get(state, `workspaces.workspace.item.id`));

  const paletteIds = useSelector((state) => _.get(state, "brandKit.activated.items", []));
  const item = useSelector(state => _.get(state, 'brandKit.components.items')) || [];
  const componentsList = useSelector(state => _.get(state, 'brandKit.components.components')) || [];
  const loading = useSelector(state => _.get(state, 'brandKit.components.loading', false));
  const fetching = useSelector(state => _.get(state, 'brandKit.components.fetching', false));
  const deleting = useSelector(state => _.get(state, 'brandKit.components.deleting', false));
  const updating = useSelector(state => _.get(state, 'brandKit.components.updating', false));
  const updated = useSelector(state => _.get(state, 'brandKit.components.updated', false));
  const error = useSelector(state => _.get(state, 'brandKit.components.error', false));
  const dataFetched = useSelector(state => _.get(state, 'brandKit.components.fetched', false));
  const createState = useSelector(state => _.get(state, 'brandKit.components.paletteComponent.create', null));
  const creating = _.get(createState, 'creating', false);
  const created = _.get(createState, 'created', false);
  const createdItem = _.get(createState, 'item', null);

  const paletteId = useMemo(
    () => _.find(paletteIds, { type: state.paletteType })?.id,
    [paletteIds, state.active]
  );

  useEffect(()=>{
    if (item?.enabled != toggleBrandElements) {
      setToggleBrandElements(item?.enabled)
    }
  },[item])

  useEffect(() => {
    if( updated ) {
      dispatch(fetchPaletteIds());
    }
  }, [updated])

  useEffect(() => { 
    if(paletteId){
      dispatch(fetchBrandkitComponents(paletteId))
    }
  }, [paletteId, state.active, created]);

  useEffect(() => {
    if (paletteId && !dataFetched) {
      dispatch(fetchBrandkitComponents(paletteId));
    }
  }, []);

  useEffect(() => {
    if (!loading && showDeleteModal && !deleting) {
      setShowDeleteModal(false);
      setState(state => {
        return {
          ...state,
          selected: []
        }
      });
    }
  }, [deleting]);

  useEffect(() => {
    if(!creating && created && createdItem) {
        dispatch(invalidatePaletteComponent())
        const url = `${process.env.REACT_APP_UI_URL}/app/${workspace}/paletteComponent/${createdItem?.id}`;
        window.open(url, '_blank');
    }
  }, [created])

  const handleTabChange = (data) => {
    setState(state => {
      return {
        active: data.name,
        label : data.label,
        paletteType: data.paletteType,
        selected:[]
      }
    })
  }

  useToastMessage(updated, invalidateBrandkitComponent, error, state.label);

  function toSingular(label) {
    return label.endsWith('s') ? label.slice(0, -1) : label;
  }

  const handleCreateComponent = (type) => {
    dispatch(createBrandkitComponent(paletteId, {name: "palette component"}, type))
  };

  const deleteModalOpenHandler = () => {
    if (state.selected?.length === 0) return;
    setShowDeleteModal(true);
  };

  const resetHandler = () => {
    if(paletteId){
      dispatch(fetchBrandkitComponents(paletteId));
    }
  };

  const saveChangesHandler = () => {
    const request = componentsList
      ?.filter(({ changes }) => changes)
      .map(({ id, name, newComponent, draft, order }) => ({
        name,
        ...(newComponent ? {} : { id }),
        order
      }));
  
    dispatch(updateBrandkitComponents(paletteId, request));
  };

  const handleDelete = () => {
    const ids = state.selected?.map(item => item.id);

    if (ids.length > 0) {
      dispatch(deleteBrandkitComponents(ids, paletteId))
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={cx(styles.categoriesList, "px-2")}>
          {Options.map((data) => (
            <span
              onClick={() => handleTabChange(data)}
              className={cx(
                styles.icons,
                state.active === data.name && styles.iconSelected
              )}
              key={data.name}
            >
              {data.label}
            </span>
          ))}
        </div>
        <div className={styles.liner}></div>
        <div className={styles.mainContainer}>
          <Header
            selectedCategory={state.label}
            toggleBrandElements={toggleBrandElements}
            setToggleBrandElements={setToggleBrandElements}
            deleteHandler={deleteModalOpenHandler}
            selectedItems={state.selected}
            loading={loading}
            paletteId={paletteId}
          >
            <Button variant="primary" onClick={() => handleCreateComponent(state.label)} className={styles.uploadButton} disabled={creating}>
              <i className="cleverstory-plus" />
              {creating ? `Creating ${toSingular(state.label)}` : `Create ${toSingular(state.label)}`}
            </Button>
          </Header>

          <div className={styles.mainContentWrapper}>
            <div>
              {(fetching) ? (
                <div className={styles.loaderContainer}>
                  <label> {`Just a moon-ute... Scanning for ${state.label?.toLowerCase()}...`} </label>
                </div>
              ) : (!dataFetched && !fetching && componentsList?.length === 0) ? (
                <EmptyMessage />
              ) : (
                componentsList?.map((data) => (
                  <Component
                    key={data.id}
                    deleting={deleting}
                    component={data}
                    availableFonts={availableFonts}
                    state={state}
                    setState={setState}
                    paletteId={paletteId}
                    workspace={workspace}
                    toSingular={toSingular}
                  />
                ))
              )}
            </div>
          </div>
        </div>
      </div>
      {showDeleteModal && (
        <DeleteModal
          showDeleteModal={true}
          message={`Are you sure you want to delete ${
            state.selected?.length > 1
              ? `these ${state.selected?.length} files?`
              : `this file?`
          }`}
          title={`Delete ${state.label}`}
          isDeleting={deleting}
          backdrop={deleting}
          cancelHandler={() => setShowDeleteModal(false)}
          handleDeleteClick={handleDelete}
        />
      )}
        <Footer        
          resetHandler={resetHandler}
          updating={updating}
          saveChangesHandler={saveChangesHandler}
          saveDisable={updating || componentsList?.length === 0}
          marginCondition={true}
          state={state}
        />
    </div>
  );
}

const Component = ({ component, workspace, state, setState, paletteId, deleting, toSingular }) => {
  const { id, icon, name } = component || {};
  const dispatch = useDispatch();

  const [show, setShow] = useState(false);
  const [renameEnabled, setRenameEnabled] = useState(false);
  const [showDeleteModal, setDeleteModal] = useState(false);
  const [headerName, setHeaderName] = useState(name);
  const multiple = true;

  const buttonEditRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    const input = inputRef?.current;
    if (!input) return;
    input.value = name;
    setHeaderName(name);
  }, [name]);

  useEffect(() => {
    let input = inputRef?.current;
    if (!input) return;
    if (renameEnabled) {
      input?.focus();
    }

    const blurHandler = () => {
      setRenameEnabled(false);
      renameHandler(id, input.value);
      setHeaderName(input.value);
    };

    const keyHandler = (event) => {
      if (event.key === "Enter") {
        blurHandler();
      }
    };

    input?.addEventListener("blur", blurHandler);
    input?.addEventListener("keydown", keyHandler);
    return () => {
      input?.removeEventListener("blur", blurHandler);
      input?.removeEventListener("keydown", keyHandler);
    };
  }, [renameEnabled]);

  const handleSelect = (text) => {
    var updated = [...state.selected];

    if (multiple) {
      const exists = updated.find(m => m.id === text.id) != null;
      if (exists) {
        updated = updated.filter(m => m.id !== text.id);
      } else {
        updated = [...updated, text];
      }
    } else {
      updated = [text];
    }
    
    setState(state => {
      return {
        ...state,
        selected: updated
      }
    })
  }

  const handleDelete = () => {
    dispatch(deleteBrandkitComponents([id], paletteId))
  };

  const renameHandler = (id, name) => {
    dispatch(renameBrandkitComponent(id, name));
  };

  const handleEditComponent = (e) => {
    e.stopPropagation();
    const url = `${process.env.REACT_APP_UI_URL}/app/${workspace}/paletteComponent/${id}`;
    window.open(url, '_blank');
  }

  return (
    <div
      className={cx(
        styles.componentStyleWrapper,
        (state.selected?.some(data => data.id === id)) && styles.componentStyleWrapperSelected
      )}
      style={{ marginTop: "0px" }}
      onClick={() => handleSelect(component)}
    >
      <div className={styles.newStyleHeaderWrapper}>
        <div>
          {!renameEnabled ?
            <TruncatedTextWithTooltip            
              content={headerName} 
              maxWidth={200}
            />
            :
            <input
              ref={inputRef}
              value={headerName}
              onChange={(e) => setHeaderName(e.target.value)}
              className={styles.widgetHeadingName}
              disabled={!renameEnabled}
            />
          }
        </div>
        <Tooltip placement="top" content="Edit">
          <Button
            variant="secondary"
            ref={buttonEditRef}
            id={`brandkitComponent_${id}`}
            className={styles.btnIcons}
            style={{ marginLeft: "auto" }}
            onClick={(e) => handleEditComponent(e)}
          >
            <i className={"cleverstory-edit"} />
          </Button>
        </Tooltip>
        <div className={styles.moreOptionsWrapper}>
          <Tooltip placement="top" content="More">
            <Button
              variant="secondary"
              className={styles.btnIcons}
              onClick={() => setShow(!show)}
            >
              <i className={"cleverstory-more"} />
            </Button>
          </Tooltip>
          {show && (
            <div
              className={styles.moreOptionsList}
              onClick={(e) => e.stopPropagation()}
            >
              <span
                onClick={() => {
                  setRenameEnabled(!renameEnabled);
                  setShow(false);
                  inputRef?.current?.focus();
                }}
              >
                Rename
              </span>
              <span
                onClick={() => {
                  setShow(false);
                  setDeleteModal(true);
                }}
              >
                Delete
              </span>
            </div>
          )}
          {showDeleteModal && (
            <DeleteModal
              showDeleteModal={true}
              message={`Are you sure you want to delete ${headerName}?`}
              title={`Delete ${toSingular(state.label)}`}
              cancelHandler={() => setDeleteModal(false)}
              isDeleting={deleting}
              backdrop={deleting}
              handleDeleteClick={handleDelete}
            />
          )}
        </div>
      </div>
      <div className={styles.buttonWrapper}>
        <IKImage
          id={`media_image_${id}`}
          className={styles.icon}
          style={{width: "100%", height: "auto"}}
          path={icon?.url || defaultContentImage}
        />
      </div>
    </div>
  );
};


export default ComponentsBrandkit;